/**
 * The legal documents shown in the program, bundled straight from docs/jogi
 * (Hungarian source, English translation for every other language).
 */
import licensesMd from "../../../docs/LICENSES.md?raw";
import dpaHu from "../../../docs/jogi/adatfeldolgozasi_szerzodes.md?raw";
import privacyHu from "../../../docs/jogi/adatkezelesi_tajekoztato.md?raw";
import subHu from "../../../docs/jogi/al_adatfeldolgozok.md?raw";
import termsHu from "../../../docs/jogi/aszf.md?raw";
import dpaEn from "../../../docs/jogi/en/data_processing_agreement.md?raw";
import imprintEn from "../../../docs/jogi/en/imprint.md?raw";
import privacyEn from "../../../docs/jogi/en/privacy_notice.md?raw";
import subEn from "../../../docs/jogi/en/sub_processors.md?raw";
import termsEn from "../../../docs/jogi/en/terms.md?raw";
import imprintHu from "../../../docs/jogi/impresszum.md?raw";

export const LEGAL_DOCS = ["terms", "dpa", "privacy", "subprocessors", "imprint"] as const;
export type LegalDoc = (typeof LEGAL_DOCS)[number];

const TEXTS: Record<LegalDoc, { hu: string; en: string }> = {
  terms: { hu: termsHu, en: termsEn },
  dpa: { hu: dpaHu, en: dpaEn },
  privacy: { hu: privacyHu, en: privacyEn },
  subprocessors: { hu: subHu, en: subEn },
  imprint: { hu: imprintHu, en: imprintEn },
};

/** The document in the user's language: Hungarian for hu, English for everyone else (translated: true). */
export function legalText(doc: LegalDoc, language: string): { markdown: string; translated: boolean; language: "hu" | "en" } {
  const hu = language === "hu";
  return { markdown: TEXTS[doc][hu ? "hu" : "en"], translated: !hu && language !== "en", language: hu ? "hu" : "en" };
}

export interface LicenseRow {
  name: string;
  version: string;
  license: string;
  homepage: string;
}

/** The shipped open-source components, from the table in docs/LICENSES.md. */
export function parseLicenses(md: string = licensesMd): LicenseRow[] {
  return md
    .split("\n")
    .filter((l) => l.startsWith("| ") && !l.startsWith("| Package") && !l.startsWith("|---"))
    .map((l) => l.split("|").slice(1, -1).map((c) => c.trim()))
    .filter((c) => c.length >= 4)
    .map(([name, version, license, homepage]) => ({ name: name!, version: version!, license: license!, homepage: homepage! }));
}
